
import { AdminSidebar } from '@/components/admin/AdminSidebar';
import { SpecialClassReport } from '@/components/admin/special-class/SpecialClassReport';
import { ReportLoading } from '@/components/reports/ReportLoading';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { useAuth } from '@/context/auth';
import { useSpecialClassReports } from '@/hooks/useSpecialClassReports';
import { supabase } from '@/integrations/supabase/client';
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

const SpecialClassReportPage = () => {
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);
  const { user } = useAuth();

  const {
    jobs,
    isLoading,
    search,
    setSearch,
    onSearch,
    showNotApproveOnly,
    setShowNotApproveOnly,
    approveSpecialClassMutation,
  } = useSpecialClassReports();

  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        if (!user) {
          setIsAdmin(false);
          return;
        }
        const { data, error } = await supabase
          .rpc('has_role', { _role: 'admin' });

        if (error) {
          console.error('Error checking admin status:', error);
          setIsAdmin(false);
          return;
        }

        // Ensure we're setting a boolean value by converting data to boolean
        setIsAdmin(!!data);
      } catch (err) {
        console.error('Error checking admin role:', err);
        setIsAdmin(false);
      }
    };

    checkAdminStatus();
  }, [user]);

  if (isAdmin === false) {
    return <Navigate to="/" replace />;
  }

  if (isAdmin === null) {
    return (
      <div className="container max-w-4xl mx-auto px-4 py-8 flex justify-center">
        <ReportLoading />
      </div>
    );
  }

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <AdminSidebar />
        <SidebarInset>
          <div className="container mx-auto px-4 py-8">
            <div className="flex justify-between items-center mb-6">
              <h1 className="text-2xl font-bold">ตารางเฉพาะกิจ</h1>
            </div>
            <SpecialClassReport
              isLoading={isLoading}
              jobs={jobs}
              search={search}
              setSearch={setSearch}
              onSearch={onSearch}
              showNotApproveOnly={showNotApproveOnly}
              setShowNotApproveOnly={setShowNotApproveOnly}
              approveSpecialClassMutation={approveSpecialClassMutation}
            />

          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default SpecialClassReportPage;
